// extracted by mini-css-extract-plugin
module.exports = {"dialog-content":"AlertConfirmDialog_dialog-content__1BNIM","message":"AlertConfirmDialog_message__2ivDg"};